import { FC } from 'react';
import { useConfigContext } from '@fe-core';
import { BxFooter } from '@fe-learner-common/components/BX/BxFooter';

type FooterProps = {
  className?: string;
  isLoading?: boolean;
};

export const Footer: FC<FooterProps> = ({ className, isLoading }) => {
  const { config } = useConfigContext();

  if (config?.client === "blanchard") {
    return <BxFooter className={className} isLoading={isLoading} />;
  }

  return null;
};
